export default __webpack_public_path__ + "static/media/4.f8451801.jpg";